/**
* @author Edgar Escobedo
* @description Splice a string with 100 letters or more and add ...
* @updatedDate 16 -03-2023
* @param {Number} String 
* @returns {String}
*/

function sliceString100AndAddPoints(cadena) {
    const textSLice = cadena.slice(0, 100).trim();
    const newText = `${textSLice}...`
    return newText
}


/**
 * @author Edgar Escobedo 
 * @description Masks a string by replacing characters with a specified mask character
 * @param {string} stringToMask - The input string to mask
 * @param {number} visible - The number of visible characters
 * @param {string} maskChar - The character to use for masking
 * @returns {string} - The masked string 
 */
const maskString = (stringToMask, visible = 3, maskChar = '*') => {
    if (!stringToMask) return ''
    const vis = Math.min(visible, stringToMask.length)
    const head = stringToMask.slice(0, vis)
    const tail = stringToMask
        .slice(vis)
        .split('')
        .map(ch => (ch === '@' ? '@' : maskChar))
        .join('')
    return head + tail
}

export { sliceString100AndAddPoints, maskString }